window.adev_new = window.adev_new || {},
    function(i) {
        "use strict";
        adev_new.new = {
            init: function() {
                this.io(), this.notificationBar(), i(document).on("shopify:section:load", e => {
                    this.io()
                }), this.sizes(), i(window).on("resize scroll", () => this.sizes()), i(document).on("click", "[data-adev-option]", function(e) {
                    var t = i(this).data("adev-option");
                    i("[data-adev-product-info]").attr("data-adev-product-info", "adev-product-info-" + t)
                })
            },
            io() {
                var e = document.querySelectorAll("[data-adev-observe]:not(.adev-ovserving)");
                if ("IntersectionObserver" in window) {
                    const t = new IntersectionObserver((e, t) => {
                        e.forEach(e => {
                            e.isIntersecting && (e.target.classList.add("adev-visible"), t.unobserve(e.target))
                        })
                    }, {
                        root: null,
                        rootMargin: "0px",
                        threshold: .8
                    });
                    e.forEach(e => {
                        e.classList.add("adev-ovserving"), t.observe(e)
                    })
                } else e.forEach(e => {
                    e.classList.add("adev-visible")
                })
            },
            notificationBar() {
                0 < i('[data-adev-notification-bar="true"]').length && i(window).on("resize scroll", function(e) {
                    i('[data-adev-notification-bar="true"]').outerHeight() + i(".header-wrapper").outerHeight() < (window.pageYOffset || document.documentElement.scrollTop) ? i("html").addClass("adev-sticky-notification") : i("html").removeClass("adev-sticky-notification")
                })
            },
            sizes() {
                i("html").css({
                    "--adev-notification-bar": i('[data-adev-notification-bar="true"]').outerHeight() + "px",
                    "--adev-sticky-header-height": (i(".sticky-header-wrapper.sticky").outerHeight() || 0) + "px",
                    "--adev-header-height": i("[data-wetheme-section-type='header']").outerHeight() + "px",
                    "--screen-width": i(window).innerWidth() + "px",
                    "--screen-height": i(window).innerHeight() + "px"
                })
            }
        }, adev_new.new.init()
    }(jQuery);


if (!customElements.get('adev-sticky-btt')) {
    customElements.define('adev-sticky-btt', class adevStickyBtt extends HTMLElement {
        constructor() {
            super();
            this.scrollThreshold = 130;
            this.handleScroll = this.handleScroll.bind(this);
            this.bttButton = this.querySelector('[data-adev-sticky-btt="go"]');
        }

        initGoToTop() {
            if (this.bttButton) {
                this.bttButton.addEventListener('click', this.scrollToTop);
            }
        }

        destroyGoToTop() {
            if (this.bttButton) {
                this.bttButton.removeEventListener('click', this.scrollToTop);
            }
        }

        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }

        connectedCallback() {
            window.addEventListener('scroll', this.handleScroll, { passive: true });
            
            this.initGoToTop();
            this.handleScroll();
        }

        disconnectedCallback() {
            window.removeEventListener('scroll', this.handleScroll);
            this.destroyGoToTop();
        }

        handleScroll() {
            const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
            
            if (scrollPosition > this.scrollThreshold) {
                this.classList.add('is--active');
            } else {
                this.classList.remove('is--active');
            }
        }

    });
}